import PropTypes from "prop-types";
import React from "react";
import { useErrors } from "shared/hooks/errors/useErrors";

class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
        this.handlePromiseRejection = this.handlePromiseRejection.bind(this);
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true, error, errorInfo });
        this.reportError(error, errorInfo);
    }

    handlePromiseRejection(event) {
        event.preventDefault();
        const error = event.reason || event;
        this.setState({ hasError: true, error });
        this.reportError(error);
    }

    componentDidMount() {
        globalThis.addEventListener("unhandledrejection", this.handlePromiseRejection);
    }

    componentWillUnmount() {
        globalThis.removeEventListener("unhandledrejection", this.handlePromiseRejection);
    }

    reportError(error, errorInfo) {
        console.error("AppErrorBoundary caught error:", error, errorInfo);
        if (this.props.onError) {
            this.props.onError(error, errorInfo);
        }
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || null;
        }
        return this.props.children;
    }
}

AppErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
    onError: PropTypes.func,
};

export default function AppErrorBoundaryWrapper(props) {
    const { handleError } = useErrors();
    return <AppErrorBoundary {...props} onError={handleError} />;
}
